<template>
	<ui-modal
		:load="loader.brokers"
		:loadSuccess="loader.saveSuccess"
		fullscreen
		name="marketing-queues-add-schedule"
	>
		<div class="page" :class="'view-mode-' + layout.viewMode">
			<!-- Conteúdo principal -->
			<div class="body">
				<div class="header body-header">
					<div>
						<div class="title">{{ pageTitleComputed }}</div>
						<div class="subtitle">Configuração de plantão de vendas</div>
					</div>
					<div class="actions">
						<ui-button v-if="!layout.showSidebar" design="md light" @click="showSidebar">Mostrar usuários</ui-button>
						<ui-button design="md primary" @click="showConfirmSave">Salvar e Fechar</ui-button>
					</div>
				</div>

				<!-- Assim que o conteúdo for carregado esconde-se o loading e mostra-se o counteúdo -->
				<div class="content body-content">
					<div class="flex-table thead">
						<div class="flex-table-line">
							<div class="cell actions">Período</div>
							<div class="cell">Segunda-feira</div>
							<div class="cell">Terça-feira</div>
							<div class="cell">Quarta-feira</div>
							<div class="cell">Quinta-feira</div>
							<div class="cell">Sexta-feira</div>
							<div class="cell">Sábado</div>
							<div class="cell">Domingo</div>
						</div>
					</div>
					<div class="flex-table">
						<div
							v-for="(period, periodIndex) in form.data.schedule"
							:key="uuid(period)"
							class="flex-table-line">
							<div class="cell actions">
								<ui-popover-select-time
									:start="form.data.schedule[periodIndex].start"
									:end="form.data.schedule[periodIndex].stop"
									@change="setPeriodTime($event, periodIndex)" />
								<ui-button class="button-remove-period" @click="removePeriod(periodIndex)">
									<i class="fal fa-minus"></i>
								</ui-button>
							</div>

							<draggable
								v-for="(day, dayIndex) in period.days"
								class="cell"
								group="name"
								:list="day"
								:sort="false"
								:key="uuid(day)"
								@change="checkMove($event, day)"
							>

								<div v-if="day.length <= 0" class="empty"></div>

								<div v-else
									v-for="(item, index) in day"
									class="card"
									:key="uuid(item)"
									:data-find-period="periodIndex"
									:data-find-day="dayIndex"
									:id="item.uid"
								>
									<ui-image :src="item.avatar" :alt="item.name" h="50" w="50" design="circle" />
									<div class="card-info">
										<div class="card-info-title">
											{{ item.name }}
										</div>
										<div class="card-info-subtitle" v-if="item.role" >
											{{ item.role }}
										</div>
									</div>
									<div class="card-close" @click="removeItemFromPeriod(day, item, index)"><i class="fal fa-times"></i></div>
								</div>
							</draggable>
						</div>
						<div class="flex-table-footer">
							<button class="button-add-period" type="button" @click="addPeriod">
								<i class="fal fa-plus"></i>
							</button>
							<div class="datetime">Atualizado em: {{ updatedDate }}</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Conteúdo lateral -->
			<transition name="aside" mode="in-out">
				<div class="aside" v-show="layout.showSidebar">
					<div class="header aside-header">
						<div>
							<div class="title">Usuários na Fila</div>
							<div class="subtitle">Clique e arraste o usuário para o dia e hora desejado.</div>
						</div>
						<button class="button-close" type="button" @click="hideSidebar">
							<i class="fal fa-times"></i>
						</button>
					</div>

					<!-- Assim que o conteúdo for carregado esconde-se o loading e mostra-se o counteúdo -->
					<div class="content aside-content">
						<div class="filters">
							<div class="buttons">
								<button
									:class="{ active: layout.viewMode == 'name' }"
									class="button"
									type="button"
									@click="changeViewMode('name')">
									Nome
								</button>
								<button
									:class="{ active: layout.viewMode == 'photo' }"
									class="button"
									type="button"
									@click="changeViewMode('photo')">
									Foto
								</button>
							</div>
						</div>
						<div class="scrollable">
							<draggable
								:list="brokers"
								:group="{ name: 'name', pull: 'clone', put: false }"
								:sort="false"
								:clone="handleClone"
								class="list"
								ghost-class="ghost"
								@end="onChangeData">
								<div v-for="item in brokers" :key="uuid(item)" class="card">
									<ui-image :src="item.avatar" :alt="item.name" h="50" w="50" design="circle" />
									<div class="card-info">
										<div class="card-info-title">
											{{ item.name }}
										</div>
										<div class="card-info-subtitle" v-if="item.role" >
											{{ item.role }}
										</div>
									</div>
									<div :class="{ active: item.count > 0 }" class="count">
										{{ item.count }}
									</div>
								</div>
							</draggable>
						</div>
					</div>
				</div>
			</transition>
		</div>

		<!-- 
			MODAL DE CONFIRMAÇÃO DE CONFIRMAR E SALVAR A AGENDA
		-->
		<ui-modal
			name="marketing-queues-add-schedule-confirm-save"
			icon="fal fa-save"
			color-circle="success"
			icon-circle
			size="xxs"
			class="alert-modal"
			above-all>
			<div class="modal-content">
				<div class="title">Deseja salvar as alterações feitas?</div>
			</div>
			<template #footer>
				<ui-button design="link md" @click="close()">Sair sem salvar</ui-button>
				<ui-button design="success md" @click="save()">Salvar alterações</ui-button>
			</template>
		</ui-modal>
	</ui-modal>
</template>

<script>
	import { uiModal } from '@/components/ui/modal'
	import { uiButton } from '@/components/ui/buttons'
	import { uiImage } from '@/components/ui'
	import uiPopoverSelectTime from '@/components/ui-facilita/popovers/popover-select-time'

	import helpers from '@/mixins/helpers'

	import { lead } from '@/services/axios'

	import draggable from 'vuedraggable'

	const moment = require('moment')
	require('moment/locale/pt-br')
	moment.locale('pt-br')

	const assert = require('assert')

	const defaultLayout = () => {
		return {
			viewMode: 'name',
			hasChanges: false,
			showSidebar: false,
		}
	}

	const defaultLoader = () => {
		return {
			shedules: false,
			brokers: false,
			saveSuccess: false,
		}
	}

	/**
	 * É uma cópia do array de brokers
	 * Usado para conferir se há alterações na agenda
	 */
	let scheduleCopy = []

	export default {
		name: 'Schedule',
		components: {
			uiModal,
			uiButton,
			uiImage,
			draggable,
			uiPopoverSelectTime,
		},

		mixins: [helpers],

		data() {
			return {
				id: null,
				pageTitle: '',
				layout: { ...defaultLayout() },
				loader: { ...defaultLoader() },
				form: {
					name: '',
					data: {
						schedule: [],
					},
				},
				brokers: [],
				selected: {},
				defaultShedule: []
			}
		},

		mounted() {
			this.$root.$on('modal-open-marketing-queues-add-schedule', (data) => {
				this.id = data.id
				this.pageTitle = data.pageTitle

				this.$nextTick(() => {
					this.loadData()
					this.addPeriod()
				})
			})
		},

		computed: {
			updatedDate() {
				let date = new Date()
				/**
				 * Usa o método nativo do Javascript Internacionalização para
				 * formatar a data que será apresentada no status de Atualização
				 * da agenda.
				 */
				return new Intl.DateTimeFormat('pt-BR', {
					dateStyle: 'full',
					timeStyle: 'long',
				}).format(date)
			},

			pageTitleComputed() {
				return this.pageTitle ? this.pageTitle : this.form.name
			},

			schedule() {
				return this.form.data.schedule
			},
		},

		methods: {
			/**
			 * Reseta o layout
			 */
			resetLayout() {
				this.layout = {
					...defaultLayout(),
				}
			},
			/**
			 * Reseta os loadings
			 */
			resetLoader() {
				this.loader = {
					...defaultLoader(),
				}
			},
			/**
			 * Fecha o modal de agenda
			 */
			close() {
				this.$root.$emit('modal-close-marketing-queues-add-schedule')
				this.$root.$emit('modal-close-marketing-queues-add-schedule-confirm-save')
				setTimeout(() => {
					this.resetLoader()
					this.resetLayout()
				}, 202)
			},
			/**
			 * Mostra o modal de confirmação de fechar
			 * se tiver alterações mostra o modal de salvar
			 * se não hou ver alterações mostra o modal de fechar
			 */
			showConfirmSave() {
				this.hasChanges()
				this.$nextTick(() => {
					if (this.layout.hasChanges) {
						this.$root.$emit('modal-open-marketing-queues-add-schedule-confirm-save')
					} else {
						this.close()
					}
				})
			},
			/**
			 * Submit de Salvar plantão
			 * Esconde o modal de confirmação de salvar
			 * Mostra o load no modal de agenda e depois fecha, voltando para a tela de Listas
			 */
			save() {
				this.$root.$emit('modal-close-marketing-queues-add-schedule-confirm-save')
				this.$set(this.loader, 'brokers', true)

				const params = {
					schedule: JSON.stringify(this.form.data.schedule),
				}

				lead.create(`${this.id}/schedule`, params)
					.then((response) => {
						setTimeout(() => {
							this.$set(this.loader, 'saveSuccess', true)
	
							setTimeout(() => {
								this.close()
							}, 2000)
						}, 2000)
					})
					.catch((error) => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						this.$set(this.loader, 'brokers', false)
					})
			},
			/**
			 * Verifica quantas vezes um usuário foi atribuído no cronograma
			 */
			countScheduledBroker(brokerId, schedule) {
				let count = 0
				for (const item of schedule) {
					for (const day in item.days) {
						count += Object.values(item.days[day]).filter((item) => item.id === brokerId).length
					}
				}

				return count
			},
			/**
			 * Carrega a lista de corretores
			 * Os metodos 'setTimeout' devem ser substituídos por requisições
			 */
			loadData() {
				this.$set(this.loader, 'brokers', true)
				lead.get(this.id, 'schedule')
					.then((response) => {
						this.brokers = Object.values(response.data.lusers).map((broker) => {
							return {
								id: broker.user_id,
								name: broker.user.first_name,
								avatar: this.getImgCDN(broker.user.cover),
								// role: 'Corretor de Mercado',
								count: this.countScheduledBroker(broker.user_id, response.data.data.schedule),
							}
						})

						this.$set(this.form, 'name', response.data.name)

						this.$set(this.form.data, 'schedule',
							Object.values(response.data.data.schedule).map((item) => {
								for (const key in item.days) {
									item.days[key] = Object.values(item.days[key])
								}
								return item
							})
						)
					})
					.catch((error) => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					})
					.finally(() => {
						//Salva uma cópia para fazer comparação
						scheduleCopy = [...this.form.data.schedule]
						this.$set(this.loader, 'brokers', false)
					})
			},
			/**
			 * Muda a forma como os corretores são mostrados na tela
			 * mudança apenas no visual
			 */
			changeViewMode(param) {
				this.$set(this.layout, 'viewMode', param)
			},
			/**
			 * Adiciona um novo periodo na agenda
			 */
			addPeriod() {
				let start = 0
				let stop = 0

				/**
				 * Verifica se é o primeiro item
				 * Se SIM: colocar a hora pradrão
				 * Se NAO: soma duas horas a partir do ultimo item da lista form.data.schedule[]
				 */
				if (this.form.data.schedule.length == 0) {
					start = 800
					stop = start + 200
				} else {
					start = moment(this.form.data.schedule[this.form.data.schedule.length - 1].stop, 'hhmm')
					stop = moment(start, 'hhmm').add(2, 'hours')
				}

				this.form.data.schedule.push({
					start: moment(start, 'hmm').format('HH:mm'),
					stop: moment(stop, 'hmm').format('HH:mm'),
					days: {
						monday: [],
						tuesday: [],
						wednesday: [],
						thursday: [],
						friday: [],
						saturday: [],
						sunday: [],
					},
				})
			},
			/**
			 * Define as horas para o período
			 */
			setPeriodTime(event, periodIndex) {
				let shed = false 
				this.form.data.schedule.forEach(e => {
					if (e.start === event.start && e.stop === event.end) {
						shed = true
					}
				})

				if (shed) {
					this.$toastr.e('Não é possível adicionar horários equivalentes.')
					const start = this.form.data.schedule[periodIndex].start
					const end = this.form.data.schedule[periodIndex].stop

					this.$set(this.form.data.schedule[periodIndex], 'start', '')
					this.$set(this.form.data.schedule[periodIndex], 'stop', '')

					this.$nextTick(() => {
						this.$set(this.form.data.schedule[periodIndex], 'start', start)
						this.$set(this.form.data.schedule[periodIndex], 'stop', end)
					})
				}else{
					this.$set(this.form.data.schedule[periodIndex], 'start', event.start)
					this.$set(this.form.data.schedule[periodIndex], 'stop', event.end)
				}
			},
			/**
			 * Remove o período da agenda
			 */
			removePeriod(index) {
				if (!this.form.data.schedule[index]) return

				for (const day of Object.values(this.form.data.schedule[index].days)) {
					for (const [iindex, item] of day.entries()) {
						this.removeItemFromPeriod(day, item, iindex)
					}
				}
				this.form.data.schedule.splice(index, 1)
			},
			/**
			 * Remove um item/card/broker de um período da agenda
			 */
			removeItemFromPeriod(day, item, index) {
				this.brokers.find((x) => x.id === item.id).count--
				day.splice(index, 1)

				this.$set(this.layout, 'hasChanges', true)
			},
			/**
			 * Quando se clona um item é alterado o seu valor em quantidade
			 * Também é removido o uid padrão para evitar conflitos
			 */
			handleClone(item) {
				this.selected = item

				let clone = JSON.parse(JSON.stringify(item))
				this.$delete(clone, 'uid')
				return clone
			},
			/**
			 * Gera um UID novo
			 */
			uuid(el) {
				if (el.uid) return el.uid
				this.$set(el, 'uid', Math.random().toString(16).slice(2))
				return el.uid
			},

			/**
			 * Verifica se o local onde o item foi solto é uma cell
			 * Caso seja aumenta a quantia no contador
			 *
			 * Caso o botão esteja desativado o ativa.
			 */
			onChangeData(event) {
				if (event.to._prevClass === 'cell') {
					this.brokers.find((x) => x.id === this.selected.id).count++

					this.$set(this.layout, 'hasChanges', true)
				}
			},
			/**
			 * Mostra o sidebar com os usuários para selecionar
			 */
			showSidebar() {
				this.$set(this.layout, 'showSidebar', true)
			},
			/**
			 * Esconde o sidebar com os usuários para selecionar
			 */
			hideSidebar() {
				this.$set(this.layout, 'showSidebar', false)
			},
			/** 
			 * Verifica se os arrays schedule de scheduleCopy são iguais
			 * Determina se há alteração na agenda
			 */
			hasChanges() {
				let schedule = this.form && this.form.data && this.form.data.schedule ? this.form.data.schedule : []

				this.$nextTick(() => {
					try {
						assert.deepStrictEqual(schedule, scheduleCopy, 'Teste exception')
						this.$set(this.layout, 'hasChanges', false)
					} catch (error) {
						this.$set(this.layout, 'hasChanges', true)
					}
				})
			},

			checkMove(e, value) {
				if(e.added) {
					
					let count = 0
					const item = e.added.element

					value.forEach(el => {
						if (item.id === el.id) {
							count ++
						}	
					})

					if (count > 1) {
						const el = document.getElementById(item.uid)

						const index = this.form.data.schedule[el.getAttribute('data-find-period')].days[el.getAttribute('data-find-day')].findIndex((x) => x.uid === item.uid)
						this.form.data.schedule[el.getAttribute('data-find-period')].days[el.getAttribute('data-find-day')].splice(index, 1)
						this.brokers.find((x) => x.id === item.id).count--
					}					
				}
			}
		},

		beforeDestroy() {
			this.$root.$off('modal-open-marketing-queues-add-schedule')
		}
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>